var map = {
	"./30.png": 94343,
	"./31.png": 41854,
	"./btc.png": 80481,
	"./cashapp.png": 42014,
	"./credit.png": 97833,
	"./csgo.png": 82186,
	"./doge.png": 45369,
	"./dota.png": 46864,
	"./eth.png": 49389,
	"./g2a.png": 5844,
	"./gift.png": 17088,
	"./kinguin.png": 99307,
	"./limiteds.png": 27083,
	"./ltc.png": 31727,
	"./papara.png": 99709,
	"./payfix.png": 35309,
	"./pix.png": 10799,
	"./placeholder.png": 6839,
	"./robux.png": 89474,
	"./sol.png": 91950,
	"./trc-20.png": 71490,
	"./trx.png": 41906,
	"./usdc.png": 59441,
	"./usdt.png": 4462
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 87493;